import { tns } from 'tiny-slider/src/tiny-slider';

// Single use instance of slider
// const articleSlider = () =>
//   tns({
//     container: '.article-slider',
//     items: 2,
//     slideBy: 'page',
//     autoplay: false,
//     autoHeight: true
//   });


// Multiple use instance of slider
// https://github.com/ganlanyuan/tiny-slider/issues/103
const articleSlider = () => {

  var forEach = function (array, callback, scope) {
    for (var i = 0; i < array.length; i++) {
      callback.call(scope, i, array[i]); // passes back stuff we need
    }
  };

  // tiny-slider initialisation
  const sliders = document.querySelectorAll('.article-slider');

  forEach(sliders, function (index, value) {
    let slider = tns({
      container: value,
      items: 2,
      slideBy: 'page',
      autoplay: false,
      autoHeight: true
    });
  });

}

export default articleSlider;

